import { useState } from "react";

export interface CollapsibleSectionProps {
  title: string;
  defaultOpen?: boolean;
  children: React.ReactNode;
}

export function CollapsibleSection({ title, defaultOpen, children }: CollapsibleSectionProps) {
  const [open, setOpen] = useState(defaultOpen ?? false);
  return (
    <div className="snap-collapsible">
      <button
        className="snap-collapsible-header"
        onClick={() => setOpen(!open)}
        type="button"
      >
        <span>{title}</span>
        <span className="snap-collapsible-arrow">{open ? "\u25BE" : "\u25B8"}</span>
      </button>
      {open && <div className="snap-collapsible-body">{children}</div>}
    </div>
  );
}
